module.exports = __webpack_public_path__ + "media/images/icon_id_copy-a28c827f6f784f81049c54f269bd8d98.svg";